import { inject } from '@angular/core';
import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { apiErrorCode } from '../utils/api-error';

/**
 * Коды ошибок, которые экран показывает сам (своим текстом или как ожидаемое
 * состояние — «бот не подключён»), поэтому тост по ним не нужен. По умолчанию
 * список пуст: остальные запросы показывают тост как раньше.
 */
export const HANDLED_ERROR_CODES = new HttpContextToken<readonly string[]>(
  () => [],
);

/**
 * Свой текст тоста по коду ошибки (код → ключ перевода) вместо текста бэкенда,
 * когда тот для пользователя не годится или не проверен.
 */
export const ERROR_CODE_TEXTS = new HttpContextToken<
  Readonly<Record<string, string>>
>(() => ({}));

// opt-out от глобального тоста — ошибку показывает вызывающая сторона
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const translate = inject(TranslateService);

  return next(req).pipe(
    catchError((error) => {
      if (req.context.get(SKIP_ERROR_TOAST)) throw error;
      const code = apiErrorCode(error);
      if (code && req.context.get(HANDLED_ERROR_CODES).includes(code)) {
        throw error;
      }
      const ownText = code ? req.context.get(ERROR_CODE_TEXTS)[code] : null;
      if (ownText) {
        toast.error(translate.instant(ownText));
      } else if (error && error.error) {
        toast.error(error.error.description);
      } else {
        toast.error(
          `${translate.instant('common.errors.default_error_message')}`,
        );
      }
      throw error;
    }),
  );
};
